import { useState, useEffect } from 'react';

/** Subscribe to a CSS media query, re-rendering when it flips. jsdom-safe:
 *  falls back to `false` when `matchMedia` is unavailable (tests, SSR). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    // Guard against a flip between the lazy init and listener attach; the
    // listener handles every flip after this point.
    setMatches((prev) => (prev === mql.matches ? prev : mql.matches));
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
